import React, {
    useEffect,
    useState
} from 'react';
import {DataGrid} from '@material-ui/data-grid';
import Header from "./Header";
import {useGrid} from "../../../hooks/crud/Grid";
import {useTranslation} from "react-i18next";
import {GridSkeleton} from "../../../components/GridSkeleton";
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { format, subDays } from 'date-fns'
import ParkingEventRepository from "../../../repositories/ParkingEventRepository";
import {
    ActionButtons, ActionButtonTypes, buildActionButton,
    DurationColumnType,
    EventDateColumnType,
    NumberPlateColumnType
} from "../../../components/Grid/Columns";
import ParkingEventDetailView from "../View";
import { saveAs } from 'file-saver'
import Filter from "../../ParkingEvent/List/Filter";

const ParkingEventListView = () => {

	const repository = new ParkingEventRepository();
	const {t}  = useTranslation();
	const [openedId, setOpenedId] = useState(null);
	const [blockedWindow, setBlockedWindow] = useState(false);

	const onViewHandler = (e) => {
	    setOpenedId(e.Id);
    }

    const handleOnDownload = async (e) => {
	    setBlockedWindow(true);
	    try {
            const response = await repository.export(Object.assign({}, filter, { sort: sort }));
            const fileName = "[" + filter.DateFrom + " - " + filter.DateTo + "] - Events.csv";
            saveAs(response.data, fileName);
        } catch (e) {
        } finally {
            setBlockedWindow(false);
        }
    }

    const today = format(new Date(), 'yyyy-MM-dd');
    const hourFrom = format(new Date(), 'HH');

	const defaultFilter = { DateFrom: today, DateTo: today, HourFrom: hourFrom };
    const defaultSort = 'Id|desc';

	const {items,
        totalCount,
        itemsOnPage,
        onPage,
        isSearching,
        onFilterChangedHandler,
        onSortChangedHandler,
        filter,
        sort,
        setFilterValue,
        updateGrid } = useGrid(repository, { defaultFilter: defaultFilter, defaultSort: defaultSort });

	useEffect(() => {

	    return () => {};
    }, [filter, sort]);

	const columns = [
        { field: 'Id', headerName: t('ID'), width: 100, sortable: false },
        { field: 'NumberPlate', headerName: t('Number plate'), ...NumberPlateColumnType },
        { field: 'EntranceDateTime', type: "dateTime", headerName: t('Entrance date'), ... EventDateColumnType },
        { field: 'ExitDateTime', type: "dateTime", headerName: t('Exit date'), ... EventDateColumnType },
        { field: 'DurationSeconds', headerName: t('Duration'), ... DurationColumnType },
        { field: 'ParkingZoneName', headerName: t('Parking zone'), width: 200, sortable: false },
        { headerName: t('Actions'), field: 'view',
            ...ActionButtons([
                buildActionButton(ActionButtonTypes.VIEW, t("View details"), onViewHandler)
            ]) }
    ];

	return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <>
             {openedId && <ParkingEventDetailView id={openedId} onClose={e => setOpenedId(false)}/>}
             <GridSkeleton title={t("Lpr events")}
                           isSearching={isSearching}
                           isBlocked={blockedWindow}
                           header={(<Header onDownload={handleOnDownload} onRefresh={updateGrid} />)}
                           filter={(<Filter filter={filter} onUpdateFilter={setFilterValue} onFilterChangedHandler={onFilterChangedHandler} onSortChangedHandler={onSortChangedHandler} sort={sort} />)}
                           grid={(<DataGrid
                                       disableMultipleSelection={true}
                                       disableColumnFilter
                                       rows={items()}
                                       rowCount={totalCount()}
                                       columns={columns}
                                       pageSize={itemsOnPage}
                                       paginationMode="server"
                                       sortingMode="server"
                                       disableColumnSelector={true}
                                       disableSelectionOnClick={true}
                                       disableColumnMenu={true}
                                       onPageChange={onPage}
                                       rowsPerPageOptions={[itemsOnPage]}
                                       hideFooterSelectedRowCount={true}
                             />)}
            />
        </>
      </MuiPickersUtilsProvider>
	);
};

export default ParkingEventListView;